/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_NumberInputs */



/**
* | output |
* | --- |
* | "Event number" |
*
* @param {Event_NumberInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_number = /** @type {((inputs?: Event_NumberInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_NumberInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Numéro d’événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisnummer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Номер события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Número de evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件编号")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント番号")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटना संख्या")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Número do evento")
	return /** @type {LocalizedString} */ ("Event number")
});